import React from 'react';
import I18n from 'app/i18n';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

interface Props {
    onBackClick: (e: React.MouseEvent<HTMLAnchorElement>) => void
}

export default class BannedInformation extends React.PureComponent<Props> {
    render(): React.ReactNode {
        return <form className="popup-form forgot-password">
            <div className="popup-form__row">
                <a className="popup-form__back" href="#" onClick={this.props.onBackClick} style={{marginLeft: 0}}>
                    <SpriteIcon name="#svg-back" size={{height: 8, width: 5}}/>
                    <span>{I18n.t('button_back_label')}</span>
                </a>
            </div>
            <div className="login-information">
                <p><SpriteIcon className="svg-default" name="#svg-lock"/>
                    {I18n.t('account_access_blocked')}</p>
                <div className="text">
                    <p>{I18n.t('your_account_blocked')}.</p>
                    <p>{I18n.t('you_can_appeal')}.</p>
                    <p>{I18n.t('it_necessary')}:</p>
                    <ul>
                        <li>{I18n.t('download_appeal_form')}</li>
                        <li>{I18n.t('fill_it_out')}</li>
                        <li>{I18n.t('send_email')}:<br/><a
                            href="mailto:support@egb.com">support@egb.com</a> {I18n.t('or')} <a
                            href="mailto:security@egb.com">security@egb.com</a></li>
                    </ul>
                    <p>{I18n.t('application_reviewed')}.</p>
                    <p>{I18n.t('thank_you_your_understanding')}.</p>
                </div>
                <a
                    className="button-adaptive"
                    href={`/docs/submission_form_${I18n.locale === 'ru' ? 'ru' : 'eng'}.pdf`}
                    download
                    data-turbo={false}
                >
                    {I18n.t('download_file')}
                </a>
            </div>
        </form>;
    }
}
